import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton} from 'core/components';
import _ from 'lodash';

function TaskNotesModalTemplate({ taskNotesModalViewStore}) {
    const {
        facilityScheduleDates,
        openTask   
    } = taskNotesModalViewStore;

    var tasks = _.map(facilityScheduleDates, ((i, key) => {
        return <div>
            <BaasicButton
                className="btn btn--base btn--primary u-mar--bottom--sml"
                label = {facilityScheduleDates.length > 1 ? 'Task '+ (key + 1) : 'Task'}
                onClick={() => openTask(i.id)}
            ></BaasicButton>
            <p><b>Corporate notes:</b> {i.facility.corporate_.description}</p>
            <p><b>Facility notes:</b> {i.facility.notes}</p>
            <p><b>Task notes:</b> {i.notes}</p>
            {facilityScheduleDates.length > 1 && (key != facilityScheduleDates.length - 1)? <hr></hr> : null }
    </div>
    }));

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Task notes</h3>
            </div>
            <div className="modal__body">
                <div className="form__group">
                    {tasks}
                </div>
            </div>
        </section> 
    )
}
 
TaskNotesModalTemplate.propTypes = {
    taskNotesModalViewStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(TaskNotesModalTemplate);
